import "../../../../../../lib/assets/javascripts/assert.js";
import "./availability_badge.js";

window.Sparkle ??= {};
window.Sparkle.WalkInAvailability ??= {};

Sparkle.WalkInAvailability.QueueLengthBadge = class QueueLengthBadge extends (
  Sparkle.WalkInAvailability.AvailabilityBadge
) {
  constructor(resourceKey, templates, options = {}) {
    const _options = jQuery.extend({ update: true, state: { open: true, queueLength: null } }, options);
    const assert = new Asserter();
    templates.closed = assert.element(templates.closed);
    templates.peopleQueued = assert.element(templates.peopleQueued);
    templates.noQueue = assert.element(templates.noQueue);

    super(resourceKey, templates, _options);
    this.update = this.update.bind(this);
    this.showBadgeCalls = this.showBadgeCalls.bind(this);
    this.renderQueueLengthVisible = this.renderQueueLengthVisible.bind(this);
    this.renderQueueDisplayNumber = this.renderQueueDisplayNumber.bind(this);
    this.renderQueueLongClass = this.renderQueueLongClass.bind(this);
    this.templates = templates;
    this.options = _options;
  }

  // PROTECTED

  update(state) {
    super.update(state);

    if (this.currentState.stale) {
      this.currentBadge = null;
    } else if (!this.currentState.open) {
      this.currentBadge = this.templates.closed;
    } else if (this.currentState.queueLength) {
      this.currentBadge = this.templates.peopleQueued;
    } else if (this.currentState.queueLength === 0) {
      this.currentBadge = this.templates.noQueue;
    } else {
      this.currentBadge = null;
    }

    if (this.currentBadge) {
      return this.showBadge(this.currentBadge, this.currentState);
    } else {
      return this.hideBadge();
    }
  }

  showBadgeCalls(content, state) {
    this.renderQueueLengthVisible(content, state.queueLength);
    this.renderQueueDisplayNumber(content, state.queueLength);
    this.renderQueueLongClass(content, state.queueLength);
    if (!state.open) {
      return this.renderNextOpenAt(content, state.nextOpenAt);
    }
  }

  // PRIVATE

  renderQueueLengthVisible(badge, queueLength) {
    badge.find("[data-queue-length-visible]").each(function () {
      if (queueLength !== jQuery(this).data("queue-length-visible")) {
        return jQuery(this).addClass("hidden");
      }
    });

    badge.find("[data-queue-length-visible-max]").each(function () {
      if (queueLength > jQuery(this).data("queue-length-visible-max")) {
        return jQuery(this).addClass("hidden");
      }
    });

    return badge.find("[data-queue-length-visible-min]").each(function () {
      if (queueLength < jQuery(this).data("queue-length-visible-min")) {
        return jQuery(this).addClass("hidden");
      }
    });
  }

  renderQueueDisplayNumber(badge, queueLength) {
    this.el.attr("data-queue-length", queueLength);

    return badge.find("[data-queue-display-number]").each(function () {
      return jQuery(this).html(queueLength);
    });
  }

  renderQueueLongClass(badge, queueLength) {
    let elements = jQuery("<div>").append(badge).find("[data-queue-long-class-if-gt]");
    if (this.el.is("[data-queue-long-class-if-gt]")) {
      elements = elements.add(this.el);
    }
    return elements.each(function () {
      if (queueLength >= jQuery(this).data("queue-long-class-if-gt")) {
        return jQuery(this).addClass("wait-list--is-long");
      }
    });
  }
};
